import React from "react";
import { Link } from "react-router-dom";
import { getImageUrl } from "../utils/utils";

export const testimonialsColumns = ({handleEdit, handleDelete, PAGE_SIZE, API_URL}) => [
   {
    key: "sno",
    label: "S.No",
    width: 50,
    sortable: false,
    render: (row, index, page) =>
      (page - 1) * PAGE_SIZE + index + 1,
  },
  {
    key: "formType",
    label: "Testimonial Type",
    sortable: true,
    render: (row) => 
        <span>
          {row.formType}
        </span>,    
  },
  {
    key: "title",
    label: "Title",
    sortable: true,
    render: (row) => (
        <span>{row.title || "-"}</span>
    )
  },
  {
    key: "image_video",
    label: "Image / Video",
    sortable: false,
    width: 150,
    render: (row) => {
      if (!row?.image_video) return "-";

      const val = row.image_video;
      const isYouTube = val.includes("youtu.be") || val.includes("youtube.com");
      const isVideo =
        val.toLowerCase().endsWith(".mp4") ||
        val.toLowerCase().endsWith(".mov") ||
        val.toLowerCase().endsWith(".avi") ||
        val.toLowerCase().endsWith(".webm") ||
        val.toLowerCase().endsWith(".mkv");

      if (isYouTube) {
        return (
          <a
            href={val}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
              padding: "5px 10px",
              borderRadius: "6px",
              backgroundColor: "#ffebee",
              color: "#c62828",
              fontSize: "12px",
              fontWeight: 600,
              textDecoration: "none",
            }}
          >
            <i className="fa fa-youtube-play" style={{ color: "red", fontSize: "14px" }} /> YouTube Video
          </a>
        );
      }

      if (isVideo) {
        return (
          <div style={{ 
            display: "inline-block",
            padding: "4px 8px",
            borderRadius: "4px",
            backgroundColor: "#e8f4f8",
            fontSize: "12px",
            fontWeight: 500
          }}>
            <span style={{ color: "#0066cc" }}>🎥 Video</span>
          </div>
        );
      }

      const fileUrl = getImageUrl(val);
      return (
        <img
          src={fileUrl}
          alt="thumb"
          width="50"
          height="50"
          style={{ objectFit: "cover", borderRadius: "3px", verticalAlign: "middle" }}
          onError={(e) => {
            e.target.style.display = "none";
          }}
        />
      );
    },
  },
{
  key: "status",
  label: "Status",
  sortable: true,
  render: (row) => (
    <div className="checkbox-wrapper-8">
        <input
          className="tgl tgl-skewed"
          type="checkbox"
          checked={row.status === "Active"}
          readOnly
        />
        <label
          className="tgl-btn"
          data-tg-off="Inactive"
          data-tg-on="Active"
        />
      </div>
  ),  
},
  {
    key: "action",
    label: "Action",
    width: 120,
    sortable: false,
    render: (row) => (
      <ul className="actionlist p-0">
        <li>
          <Link  onClick={() => handleEdit(row)}>
            <i className="fa fa-edit" />
          </Link>
        </li>
        <li>
          <Link  onClick={() => handleDelete(row._id)}>
            <i className="fa fa-trash" />
          </Link>
        </li>
      </ul>
    ),
  },
];
